module.exports = __webpack_public_path__ + "img/logo.a1a43344.png";